const isNonProd = () => {
  return (
    !process.env.REACT_APP_BUILDENV ||
    ['local', 'dev', 'staging'].includes(
      process.env.REACT_APP_BUILDENV,
    )
  );
};

const isLocalOrDev = () => {
  return (
    !process.env.REACT_APP_BUILDENV ||
    ['local', 'dev'].includes(process.env.REACT_APP_BUILDENV)
  );
};

const envCheckers = { isNonProd, isLocalOrDev };
export default envCheckers;
